import { render, staticRenderFns } from "./BenchmarkIcon.vue?vue&type=template&id=3e36c765&scoped=true"
import script from "./BenchmarkIcon.vue?vue&type=script&lang=js"
export * from "./BenchmarkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e36c765",
  null
  
)

export default component.exports